import { render } from "./MobileNotSupported.vue?vue&type=template&id=8fcdb588&scoped=true"
import script from "./MobileNotSupported.vue?vue&type=script&lang=js"
export * from "./MobileNotSupported.vue?vue&type=script&lang=js"

import "@/Common/Styles/mobileNotSupported.scss?vue&type=style&index=0&id=8fcdb588&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8fcdb588"]])

export default __exports__